export const useEmployeesStore = defineStore('employees', () => {
  const employees = ref([])

  const setEmployees = (newEmployees) => {
    employees.value = newEmployees
  }

  const getEmployees = computed(() => employees.value)

  return {
    employees,
    setEmployees,
    getEmployees,
  }
})
